import lazyWithReload from '../../utils/lazyWithReload';

// The screen each quote flow ends on, by route. App.js routes them from this
// map; each loads as its own chunk (see lazyWithReload).
export const RESULT_PAGES = {
  '/vehicleQuoteResults': lazyWithReload(() => import('./ResultPage')),
  '/lifeQuoteResults': lazyWithReload(() => import('./LifeResultPage')),
  '/medicalGapQuoteResults': lazyWithReload(
    () => import('./MedicalGapResultPage')
  ),
  '/medicalAidQuoteResults': lazyWithReload(
    () => import('./MedicalAidResultPage')
  ),
  '/medicalInsuranceQuoteResults': lazyWithReload(
    () => import('./MedicalInsuranceResultPage')
  ),
  '/funeralQuoteResults': lazyWithReload(() => import('./FuneralResultPage')),
  '/petQuoteResults': lazyWithReload(() => import('./PetResultPage')),
  '/travelQuoteResults': lazyWithReload(() => import('./TravelResultPage')),
  '/scratchAndDentQuoteResults': lazyWithReload(
    () => import('./ScratchAndDentResultPage')
  ),
  '/tyreAndRimQuoteResults': lazyWithReload(
    () => import('./TyreAndRimResultPage')
  ),
  '/servicePlansQuoteResults': lazyWithReload(
    () => import('./ServicePlansResultPage')
  ),
  '/motorWarrantyQuoteResults': lazyWithReload(
    () => import('./MotorWarrantyResultPage')
  ),
  '/vehicleTrackingQuoteResults': lazyWithReload(
    () => import('./VehicleTrackingResultPage')
  ),
  '/debtCounsellingQuoteResults': lazyWithReload(
    () => import('./DebtCounsellingResultPage')
  ),
  '/businessInsuranceQuoteResults': lazyWithReload(
    () => import('./BusinessInsuranceResultPage')
  ),
  '/employeeBenefitsCallbackRequest': lazyWithReload(
    () => import('../quote_selected/StandaloneCallback')
  ),
  '/businessLegalCoverQuoteResults': lazyWithReload(
    () => import('./BusinessLegalCoverResultPage')
  ),
  '/commercialPropertyQuoteResults': lazyWithReload(
    () => import('./CommercialPropertyResultPage')
  ),
  '/professionalLiabilityQuoteResults': lazyWithReload(
    () => import('./ProfessionalLiabilityResultPage')
  ),
  '/homeContentsQuoteResults': lazyWithReload(
    () => import('./HomeContentsResultPage')
  ),
  '/buildingInsuranceQuoteResults': lazyWithReload(
    () => import('./BuildingInsuranceResultPage')
  ),
  '/motorcycleQuoteResults': lazyWithReload(
    () => import('./MotorcycleInsuranceResultPage')
  ),
  '/combinedInsuranceQuoteResults': lazyWithReload(
    () => import('./CombinedInsuranceResultPage')
  ),
  '/personalLoanQuoteResults': lazyWithReload(
    () => import('./PersonalLoanResultPage')
  ),
  '/debtConsolidationQuoteResults': lazyWithReload(
    () => import('./DebtConsolidationResultPage')
  ),
  '/fibreQuoteResults': lazyWithReload(() => import('./FibreResultPage')),
};

// Downloads a flow's results screen once the browser is idle, so the
// visitor doesn't wait on it after the last question. The question engine
// calls this as a flow starts.
export function preloadResultPage(path, win = window) {
  const page = RESULT_PAGES[path];
  if (!page) return;
  const preload = () => page.preload();
  if (typeof win.requestIdleCallback === 'function') {
    win.requestIdleCallback(preload, { timeout: 5000 });
  } else {
    win.setTimeout(preload, 1000);
  }
}
